import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const RequireAuth = ({ allowedRoles }) => {
    const { currentUser } = useSelector((state) => state.user);
    // const { auth } = useAuth();
    const location = useLocation();

    // console.log(allowedRoles);

    const isAuthorized = () => {
        if (allowedRoles?.includes('any') && currentUser?.userName) {
            return true;
        }

        for (let i = 0; i < currentUser?.roles.length; i++) {
            if (allowedRoles?.includes(currentUser?.roles[i])) {
                return true;
            }
        }

        return false;
    }


    return (
        // allowedRoles?.includes(currentUser?.roles)
        isAuthorized()
            ? <Outlet />
            : currentUser?.userName
                ?
                <Navigate to="/unauthorized" state={{ from: location }} replace />
                :
                <Navigate to="/?login=1" state={{ from: location }} replace />
    )
}

export default RequireAuth;